// Intro shot: the wide view with the name in 3D.
import * as THREE from 'three';
import { FontLoader } from 'three/addons/loaders/FontLoader.js';
import { TextGeometry } from 'three/addons/geometries/TextGeometry.js';
import helvetikerBoldUrl from 'three/examples/fonts/helvetiker_bold.typeface.json?url';
import { renderer } from '../core/renderer.js';
import { cam, controls, scene } from '../core/scene.js';
import { composer, paint, setTilt } from '../core/post.js';
import { P, add } from '../lib/factory.js';
import { nightMats } from '../materials/night.js';
import { V } from '../world/sagrada.js';
import { state } from '../core/state.js';

export let INTRO, nameGroup, introCam;

export function buildIntro() {
  introCam = function introCam(time) {
    cam.position.set(
      INTRO.pos.x + Math.sin(time * 0.25) * 0.6,
      INTRO.pos.y + Math.sin(time * 0.4) * 0.12,
      INTRO.pos.z,
    );
    cam.lookAt(INTRO.look);
  };

  addEventListener('resize', () => {
    cam.aspect = innerWidth / innerHeight;
    cam.updateProjectionMatrix();
    renderer.setSize(innerWidth, innerHeight);
    composer.setSize(innerWidth, innerHeight);
    paint.uniforms.px.value.set(1 / innerWidth, 1 / innerHeight);
    state.mode === 'ride' ? setTilt(0.42, 1.3) : setTilt(0.5, 3);
  });
  // ---------- intro: wide shot of the city, the name in 3D, me on the bike in the foreground ----------
  INTRO = { pos: V(8.2, 2.7, 56.4), look: V(-1, 3.6, 20) };
  cam.position.copy(INTRO.pos);
  cam.lookAt(INTRO.look);
  controls.enabled = false;
  controls.autoRotate = false;
  cam.fov = 58;
  cam.updateProjectionMatrix();
  setTilt(0.45, 0.6);
  nameGroup = new THREE.Group();
  nameGroup.position.set(0, 20.5, 18);
  scene.add(nameGroup);
  new FontLoader().load(helvetikerBoldUrl, (font) => {
    const front = P(0xfbf7ee, {
        roughness: 0.3,
        metalness: 0.1,
        emissive: 0xfff1d6,
        emissiveIntensity: 0,
      }),
      side = P(0xd9a441, {
        roughness: 0.25,
        metalness: 0.8,
        emissive: 0xd98a20,
        emissiveIntensity: 0,
      });
    nightMats.push([front, 0.9], [side, 0.35]);
    const line = (txt, size, depth, y) => {
      const g = new TextGeometry(txt, {
        font,
        size,
        height: depth,
        curveSegments: 10,
        bevelEnabled: true,
        bevelThickness: depth * 0.25,
        bevelSize: size * 0.035,
        bevelSegments: 4,
      });
      g.center();
      const m = add(g, [front, side], 0, y, 0, nameGroup);
      return m;
    };
    line('JAVIER CASTELLANO', 2.3, 0.7, 1.4);
    line('PRODUCT & ENGINEERING LEAD', 0.82, 0.25, -1.2);
  });
}
